import {createFeatureSelector, createSelector,  ActionReducerMap, } from '@ngrx/store';
import * as fromLayout from '../reducers/layout.reducer';


export interface State {
  layout: fromLayout.LayoutState;
}

export const reducers: ActionReducerMap<State> = {
  layout: fromLayout.reducer,
};

export const selectLayoutState = createFeatureSelector<fromLayout.LayoutState>('layout');

export const getTilesState = createSelector(
  selectLayoutState,
  LayoutState => LayoutState.tiles
);

export const allTilesLoaded = createSelector(
  getTilesState,
  tilesState => tilesState.allTilesLoaded
);

export const selectAllTiles = createSelector(
  getTilesState,
  fromLayout.selectAll

);

export const getSelectedTab = createSelector(
  selectLayoutState,
  state => {
    if (state.selectedTile === null) {
      const tiles = Object.values(state.tiles.entities) as any[];
      const selectedTile = tiles.find(x => x.firstLineText === state.defaultTabSelection);

      return { selectedTile, isRightPanelOpen: state.isRightPanelOpen};
    }
    return { selectedTile: state.selectedTile, isRightPanelOpen: state.isRightPanelOpen};
  }
);


export const selectRightPanelOpen = createSelector(
  selectLayoutState,
  state => state.isRightPanelOpen
);
export const selectIsHeaderVisible = createSelector(
  selectLayoutState,
  state => state.isHeaderVisible
);
export const selectRoutedTab = createSelector(
  selectLayoutState,
  state => state.routedTab
);


